import { useChatSidebar } from '@/contexts/useChatSidebar';
import {
  type ShortcutConditionData,
  useShortcutConditionData,
} from '@/hooks/useShortcutConditionData';

import { type Shortcut, getShortcuts } from '@/components/chat/shortcutsConfig';

const evaluateCondition = (
  shortcut: Shortcut,
  data: ShortcutConditionData
): boolean => data[shortcut.condition];

export const useShortcuts = (): Shortcut[] => {
  const { pageContext } = useChatSidebar();
  const conditionData = useShortcutConditionData(pageContext);

  if (!pageContext) {
    return [];
  }

  return getShortcuts(pageContext).filter((shortcut) =>
    evaluateCondition(shortcut, conditionData)
  );
};
